import React from 'react'

export default function Input({ type = "text", name = "", label = "", error = "", ...props }) {
    return (
        <div className="relative mb-4 flex flex-col">
            <label htmlFor="full-name" className="tracking-wide text-gray-700 text-xs font-bold mb-2">{label}</label>
            <input type={type} id={name} name={name} {...props} className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
            <p className="text-s text-red-500 mt-3">{error}</p>
        </div>
    )
}
export function FormInput({ type = "text", name = "", label = "", error = "", width = "full", placeholder = "placeholder", ...props }) {
    return (
        <div className={`w-full px-3 sm:w-1/2`}>
            <div className="mb-5">
                <label
                    htmlFor={name}
                    className="mb-3 block text-base font-medium text-[#07074D]"
                >
                    {label}
                </label>
                <input
                    type={type}
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    {...props}
                    className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                />
                <p className="text-s text-red-500 mt-3">{error}</p>
            </div>
        </div>
    )
}
export function FormRow({children,mx=0,my=0}){

    return (
        <div className={`-mx-${mx} my-${my} flex flex-wrap`}>
            {children}
        </div>
    )
}
export function RadioButtonGroup({ name = "", label = "", options = [], ...props }) {
    return (
        <div className="mx-4 mb-5">
            <label className=" mb-3 block text-base font-medium text-[#07074D]">
                {label}
            </label>
            <div className="flex items-center space-x-6">
                {options.map(option=><RadioButton name={name} option={option}  key={option+name} defaultChecked={option===props.selected} {...props} />)}
            </div>
        </div>
    )
}
function RadioButton({ name = "", option ,...props}) {
    return (
        <div className="flex items-center" key={name+option}>
        <input
            type="radio"
            name={name}
            className="h-5 w-5"
            value={option}
            {...props}
        />
        <label
            htmlFor="radioButton1"
            className="pl-3 text-base font-medium text-[#07074D]"
        >
            {option}
        </label>
    </div>
    )
}

